/**
 * API CEI Apps
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `1` - 1º semestre * `2` - 2º semestre
 */
export enum SemestreEnum {

    _1 = '1',

    _2 = '2'
}

